package com.banyan.flightviewer.data

/**
 * Categorizes ICAO aircraft type designators into visual categories for map icons.
 */
object AircraftTypeDatabase {

    enum class Category { JET, WIDEBODY, TURBOPROP, LIGHT, HELICOPTER, MILITARY, UNKNOWN }

    private val widebody = setOf(
        "A332", "A333", "A338", "A339", "A342", "A343", "A345", "A346",
        "A359", "A35K", "A380", "A388",
        "B744", "B748", "B74S", "B752", "B753", "B762", "B763", "B764",
        "B772", "B773", "B77L", "B77W", "B778", "B779", "B788", "B789", "B78X",
        "DC10", "MD11", "IL96", "A3ST",
    )

    private val helicopter = setOf(
        "R22", "R44", "R66", "EC20", "EC25", "EC30", "EC35", "EC45",
        "EC55", "EC75", "EC60", "EC15", "B06", "B06T", "B105", "B212",
        "B222", "B230", "B407", "B412", "B429", "B430", "B505", "BK17",
        "S76", "S92", "A109", "A119", "A139", "A149", "A169", "A189",
        "AS32", "AS50", "AS55", "AS65", "H500", "H60", "LYNX", "PUMA",
        "S61", "MD52", "MD60", "R900", "EXPL", "COUR", "KMAX",
        "UH1", "UH60", "AH1", "AH64", "CH47", "CH53", "V22",
    )

    private val turboprop = setOf(
        "AT43", "AT44", "AT45", "AT46", "AT72", "AT73", "AT75", "AT76",
        "DH8A", "DH8B", "DH8C", "DH8D", "SF34", "J328", "JS31", "JS32",
        "SW4", "SB20", "E120", "B190", "BE20", "BE30", "BE35", "C208",
        "C210", "DHC6", "DHC7", "L410", "MA60", "AN24", "AN26", "IL18",
        "P180", "PC12", "TBM7", "TBM8", "TBM9", "CONI",
    )

    private val light = setOf(
        "C150", "C152", "C162", "C172", "C177", "C180", "C182", "C185",
        "C206", "C210", "C310", "C337", "C340", "C402", "C404", "C414",
        "C421", "C425", "C441", "C500", "C510", "C525", "C550", "C560",
        "P28A", "P28B", "P28R", "P28T", "PA18", "PA24", "PA28", "PA30",
        "PA31", "PA32", "PA34", "PA44", "PA46", "PA60",
        "AA5", "BE33", "BE36", "BE40", "BE55", "BE58", "BE76", "BE9L",
        "DA20", "DA40", "DA42", "DA62", "DR40", "DV20",
        "M20P", "M20T", "RV6", "RV7", "RV8", "RV10", "SR20", "SR22",
        "COLT", "ECHO", "PIVI", "SIRA", "TRIN",
    )

    private val military = setOf(
        "F16", "F18", "F15", "F22", "F35", "F14",
        "A10", "B1", "B2", "B52", "C5", "C17", "C130", "C2",
        "E3", "E6", "E8", "KC10", "KC30", "KC35", "KC46", "K35R",
        "P8", "RC35", "T6", "T38", "U2", "EUFI", "RFAL", "GROB",
        "HAWK", "TUCA", "TORN", "GLEX",
    )

    fun getCategory(typeCode: String): Category {
        if (typeCode.isBlank() || typeCode == "Unknown") return Category.UNKNOWN
        val code = typeCode.uppercase()
        return when {
            helicopter.contains(code) -> Category.HELICOPTER
            military.contains(code) -> Category.MILITARY
            widebody.contains(code) -> Category.WIDEBODY
            turboprop.contains(code) -> Category.TURBOPROP
            light.contains(code) -> Category.LIGHT
            // Default: anything not categorized with a type code is assumed jet
            else -> Category.JET
        }
    }
}
